module.exports = __webpack_public_path__ + "img/nohead.e7705f8f.png";